import mailSVG from '../../assets/icons/mail.svg'
import passwordSVG from '../../assets/icons/password.svg'
// import Typography from '../typography/Typography';
import { Typography } from '@mui/material';
import phoneSVG from '../../assets/icons/phone.svg'
import './input.scss'
import { useState } from 'react';
import showPassword from '../../assets/icons/showpassword.svg'
import hidePassword from '../../assets/icons/hidePassword.svg'
// input props options
// placeHolderIcon =  email | password

const Input = ({ monileNumber, icon, error, type, label, value, onChange, startIcon, placeholder, labelFontSize,errors, labelfontWeight
  , labelTextColor, blur, ...rest }) => {
  const [isPassVisible, setIsPassVisible] = useState(false)
  const placeHolderIcon = {
    'email': mailSVG,
    'password': passwordSVG

  }
  return (
    <div className="input-wrapper-inner">

     

      {label && <label htmlFor={rest.id}>
        <Typography 
          transform='capitalize'
          textType={labelFontSize} 
          justify='left' 
          textColor={labelTextColor}
          textWeight={labelfontWeight} >  
          {label}
          {startIcon &&  <div style={{ color: 'red' }}>  
            {startIcon}
          </div>}
        </Typography> </label>}
      
      {monileNumber ?
        <>
          <div className={`otp-wrapper  flex justify-center align-center border-${errors ||(error && blur) ? 'red' : 'normal'}`}>
            {/* <div className='box flex justify-center align-center'>
              <img src={phoneSVG} />
            </div>
            <div className='box flex justify-center align-center'>
              <Typography textColor='black' textWeight='600'>+91</Typography>
            </div> */}
            <input autoFocus={true} value={value} onChange={onChange} placeholder='Enter your email' {...rest} />
          </div>
        </>
        :
        <>
          <div className='wrapper'>
            <input
              className={`${icon ? 'padding' : 'no-padding'} border-${errors || (error && blur) ? 'red' : 'normal'}`}
              type={isPassVisible ? 'text' : type}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              {...rest}
            />
            {icon && <img src={placeHolderIcon[icon]} alt='icon' />}
            {type === 'password' && (
              <img
                src={isPassVisible ? showPassword : hidePassword} // Use hidePassword when isPassVisible is true
                className='show-pass'
                alt='icon'
                onClick={() => setIsPassVisible(prev => !prev)}
              />
            )}
          </div>
        </>}
      {error && blur && <Typography textType='error' justify='left' textColor='red' className='login-error-message'>{error}</Typography>}
    </div>
  );
};
export default Input